var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-bar',[_vm._t("default"),_c('go-back-btn')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }